import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
} from "node-library/dist/portal";
import OrderRow from "./orderRow";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { SortArrowIcon } from "../../../../common-components/svgIcons";
import Restricted from "../../../../permissionProvider/Restricted";
import { Permission } from "../../../../permissionProvider/PermissionProvider";

interface Props {
	orders: Array<FrontendProductOrder>;
	user: FrontendUserInfo | undefined;

	isInAdminView: boolean;
	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	deleteOrder: (order: FrontendProductOrder) => void;

	goToEditOrderPage: (order: FrontendProductOrder) => void;
	goToViewOrderDetails: (order: FrontendProductOrder) => void;
	viewOrderCOC: (order: FrontendProductOrder) => void;

	goToOrderReportPage: (order: FrontendProductOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewOrdersTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		orders,
		isInAdminView,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		deleteOrder,
		goToViewOrderDetails,
		goToEditOrderPage,
		viewOrderCOC,
		goToOrderReportPage,
		setDiscardOrderConfirmOpen,
		setProceedAction,
	} = props;

	const headerItems = [
		// {
		// 	title: translation("Item"),
		// },
		{
			title: translation("OrderNo"),
			gridColumn: "1",
		},
		{
			title: translation("Date"),
			gridColumn: "2",
		},
		{
			title: translation("Total"),
			permission: Permission.PRICE,
			gridColumn: "3",
		},
		{
			title: translation("Status"),
			gridColumn: "4",
		},
	];

	const orderRows: Array<React.ReactNode> = orders
		? orders.map((order: FrontendProductOrder, index: number) => {
				return (
					<OrderRow
						key={order.orderId}
						order={order}
						user={props.user}
						goToViewOrderDetails={() => goToViewOrderDetails(order)}
						goToOrderReportPage={() => goToOrderReportPage(order)}
						deleteOrder={() => {
							setProceedAction(() => () => deleteOrder(order));
							setDiscardOrderConfirmOpen(true);
						}}
					/>
				);
		  })
		: [];

	// Filter based on permissions
	const headerRowItems: React.ReactNode = headerItems.map((item, index) => {
		return (
			<Restricted
				key={item.title}
				to={item.permission ? (item.permission as Permission) : Permission.ALL}
			>
				<div
					style={{
						display: "flex",
						gridColumn: item.gridColumn,
						marginLeft: "-10px",
						gap: "10px",
					}}
				>
					<Divider orientation="vertical" flexItem></Divider>
					<div
						className="typography-body-01"
						style={{
							color: NeutralColor.NEUTRAL_GREY_400,
							display: "flex",
							alignItems: "center",
							gap: "5px",
						}}
					>
						{item.title}
						{/* {item.sortColumnBy && (
						<SortArrowIcon
							sortOrder={sortOrder}
							notInUse={sortBy !== item.sortColumnBy}
						/>
					)} */}
					</div>
				</div>
			</Restricted>
		);
	});

	const orderRowContainer: React.ReactNode = (
		<Card sx={{ margin: "0px", padding: "16px 0px", borderRadius: "0px" }}>
			{orderRows}
		</Card>
	);

	return (
		<>
			<div className="order-list-view-row order-list-view-header">
				{headerRowItems}
			</div>
			{orderRowContainer}
		</>
	);
}
